import styles from "./styles.module.scss";
import { _ } from "i18n";
import { Paperclip } from "lucide-react";
import { Button } from "ui-kit-v2/src/button/button";
import { getClipLabel } from "common/src/gamePage/utils/clips";
import type { MergedGpEventResponse } from "common/src/gamePage/types";

interface CoachReviewsAttachedEventsProps {
	events: MergedGpEventResponse[];
	onEditClick: () => void;
	canEdit?: boolean;
}

export const CoachReviewsAttachedEvents = ({ events, canEdit = true, onEditClick }: CoachReviewsAttachedEventsProps) => {
	return (
		<div className={styles.events}>
			<div className={styles["events__header"]}>
				<div className={styles["events__header-left"]}>
					<Paperclip size={14} />
					<p>{_("game.coachReviews.attachedEvents.label", { count: events.length })}</p>
				</div>
				<Button
					onClick={onEditClick}
					className={styles["events__edit-button"]}
					type="button"
					variant="ghost"
					size="small"
					disabled={!canEdit}
				>
					{_("game.coachReviews.attachedEvents.button.label")}
				</Button>
			</div>
			<div className={styles["events__list"]}>
				{events.map((event) => (
					<div key={event.id} className={styles["events__item"]}>
						<span>{getClipLabel(event) || ""}</span>
					</div>
				))}
			</div>
		</div>
	);
};
